import "./module/userAgentChecker.min.js"
import "./module/plugin.js"

//商品Slide
import Swiper from 'swiper/bundle';
var myswiper01 = new Swiper('.property__containerSlideSlider',{
  simulateTouch:  false
});

var $ = require('jquery');
$('.property__containerSlideThumBox').first().addClass('active');

// slideToメソッドを実行する関数を定義
$('.property__containerSlideThumBoxIn').on('click', function(){
  var elm = $(this).parent().index();
  myswiper01.slideTo(elm);
  $(this).parent().toggleClass('active');
  $('.property__containerSlideThumBoxIn').not(this).parent().removeClass('active');
});

var myswiper02 = new Swiper(".info__innerBlockItemSlider", {
  spaceBetween: 10,
  slidesPerView: 'auto',
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    667: {
      spaceBetween: 30,
    }
  }
});

var myswiper03 = new Swiper(".recommend__innerBlockItemSlider", {
  spaceBetween: 10,
  slidesPerView: 'auto',
  loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    667: {
      spaceBetween: 30,
    }
  }
});